module.exports = __webpack_public_path__ + "img/ic_chevron_circle_next.827151a4.svg";